/* eslint-disable eqeqeq */

import React from 'react';
import { useTranslation } from 'react-i18next';

import { regionModel } from '../../../constants';
import { LabeledSelect } from '..';

export const RegionsDropdown = (
  { label, id, onChange, withAsterisks, disabled, value, ...props }
) => {

  const [ t ] = useTranslation();

  const options = [
    // { value: '', text: t('fields.region.placeholder') },
    { value: regionModel.ALBAHAH, text: t('fields.region.albahah') },
    { value: regionModel.ALJAWF, text: t('fields.region.aljawf') },
    { value: regionModel.ALMADINAH, text: t('fields.region.almadinah') },
    { value: regionModel.ALQASSIM, text: t('fields.region.alqassim') },
    { value: regionModel.ASIR, text: t('fields.region.asir') },
    { value: regionModel.EASTERN_REGION, text: t('fields.region.easternRegion') },
    { value: regionModel.HAIL, text: t('fields.region.hail') },
    { value: regionModel.JIZAN, text: t('fields.region.jizan') },
    { value: regionModel.MAKKAH, text: t('fields.region.makkah') },
    { value: regionModel.NAJRAN, text: t('fields.region.najran') },
    { value: regionModel.NORTHERN_BORDERS, text: t('fields.region.northernBorders') },
    { value: regionModel.RIYADH, text: t('fields.region.riyadh') },
    { value: regionModel.TABUK, text: t('fields.region.tabuk') },
    { value: regionModel.OUTSIDE_KSA, text: t('fields.region.outsideKsa') }
  ];

  const getRegionById = rId => {
    for (const [ key, val ] of Object.entries(regionModel)) {
      // eslint-disable-next-line eqeqeq
      if (val == rId) {
        if (key.includes('_')) {
          const index = key.indexOf('_');
          const fixedKey
           = key.substring(0, index).toLocaleLowerCase()
           + key.charAt(index + 1).toUpperCase()
           + key.substring(index + 2).toLocaleLowerCase();

          return t(`fields.region.${fixedKey}`);
        }

        return t(`fields.region.${key.toLocaleLowerCase()}`);
      }
    }

    return false;
  };


  return (
    <LabeledSelect
      withDebounceSearch={ true }
      label={ label }
      id={ id }
      onChange={ onChange }
      showSearch
      searchDelay={ 0 }
      options={ options }
      filterOption={ (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 }
      EmptyComponent={ t('ERR.noMatchedRegion') }
      withAsterisks={ withAsterisks }
      allowClear
      disabled={ disabled }
      placeholder={ t('fields.region.placeholder') }
      value={ value ? getRegionById(value) : undefined }
      { ...props }
    />
  );
};
